
import { getPercentage } from "@/helpers";
import { defineComponent, computed } from "vue";

export default defineComponent({
  name: "ScoreAverageScaler",
  props: {
    playerScore: {
      type: Number,
      default: 0,
      required: true,
    },
    communityScore: {
      type: Number,
      default: 0,
      required: true,
    },
    max: {
      type: Number,
      required: true,
    },
    min: {
      type: Number,
      required: true,
    },
    isCommunity: {
      type: Boolean,
      required: true,
    },
  },
  setup(props) {
    const player = computed(() => {
      return getPercentage(props.playerScore, props.min, props.max);
    });

    const validatedCommunityScore = computed(() => {
      if (isNaN(props.communityScore)) {
        return 0;
      } else {
        return props.communityScore;
      }
    });

    const community = computed(() => {
      return getPercentage(validatedCommunityScore.value, props.min, props.max);
    });

    const playerScoreText = computed(() => {
      return props.isCommunity ? props.playerScore : "Your city";
    });
    const communityScoreText = computed(() => {
      return props.isCommunity ? "Avg. City" : validatedCommunityScore.value;
    });

    return {
      player,
      community,

      playerScoreText,
      communityScoreText,
    };
  },
});
